import axios from "axios";
import { apiUrl } from "./index";

const api = axios.create({
  baseURL: apiUrl,
});



export const getAxiosRequestConfig = (token) => ({
  headers: {
    Authorization: token,
  },
});

export const errorHandler = (
  error,
  fallbackMessage = "Unable to process request"
) => {
  if (error?.code === "ERR_NETWORK") {
    return error.message || fallbackMessage;
  }
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  return error.message || fallbackMessage;
};

export default api;
